import PropTypes from "prop-types";
import React from "react";

export default class SetInterval extends React.Component {
  componentDidMount() {
    const interval = this.props.interval;
    this.interval = setInterval(this.props.apiCall, interval);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    //eslint-disable-line class-methods-use-this
    return null;
  }
}

SetInterval.propTypes = {
  interval: PropTypes.number.isRequired,
  apiCall: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./components/common/CallbackOnInterval.js